/**
 * Utility functions for chart configuration
 */

export function getChartOptions() {
  var bodyStyles = getComputedStyle(document.body);
  var themeColor = (bodyStyles.getPropertyValue('--bs-theme') || '#495057').trim();
  var themeColorRgb = (bodyStyles.getPropertyValue('--bs-theme-rgb') || '73,80,87').trim();

  if (themeColor === "") themeColor = '#495057';
  if (themeColorRgb === "") themeColorRgb = '73,80,87';
  
  return {
    bar: {
      colors: [themeColor],
      chart: { 
        type: 'bar',
        sparkline: { enabled: true } 
      },
      tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
    },
    line: {
      colors: [themeColor],
      chart: { 
        type: 'line',
        sparkline: { enabled: true } 
      },
      stroke: { curve: 'straight', width: 2 },
      tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
    },
    pie: {
      colors: ['rgba('+ themeColorRgb + ', 1)', 'rgba('+ themeColorRgb + ', .75)', 'rgba('+ themeColorRgb + ', .5)'],
      chart: { 
        type: 'pie',
        sparkline: { enabled: true } 
      },
      stroke: { show: false },
      tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
    },
    donut: {
      colors: ['rgba('+ themeColorRgb + ', .15)', 'rgba('+ themeColorRgb + ', .35)', 'rgba('+ themeColorRgb + ', .55)', 'rgba('+ themeColorRgb + ', .75)', 'rgba('+ themeColorRgb + ', .95)'],
      chart: { 
        type: 'donut',
        sparkline: { enabled: true } 
      },
      stroke: { show: false },
      tooltip: { x: { show: false }, y: { title: { formatter: function (seriesName) { return '' } } } }
    }
  };
}